import {
  Autocomplete,
  Box,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";

const ConfigureDefaultIssueParams = ({ jiraState }) => {
  return (
    <Box mt={2}>
      <Typography variant="h6">
        Configure Default Labels for Manual Ticketing
      </Typography>
      <Typography variant="subtitle2">
        Each ticket created from Breeze will include these labels by default.
      </Typography>

      <Autocomplete
        options={[]}
        value={jiraState.defaultLabels}
        multiple
        freeSolo
        filterSelectedOptions
        onChange={(event, newValue) => jiraState.setDefaultLabels(newValue)}
        PopperComponent={({ children, ...props }) => {
          const { anchorEl } = props;
          const width = anchorEl ? anchorEl.offsetWidth : undefined;
          return (
            <Popper {...props} style={{ minWidth: width }}>
              {children}
            </Popper>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} margin="dense" label="Labels" fullWidth />
        )}
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <SecondaryButton
          onClick={jiraState.handleSaveDefaultIssueConfig}
          sx={{ marginTop: "20px", width: "100px", height: "30px" }}
        >
          Save
        </SecondaryButton>
      </Box>
    </Box>
  );
};

export default ConfigureDefaultIssueParams;
